<div class="row border rounded m-1 p-1">
    <div class="row row-cols-lg-auto gx-2">
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#scheduleModal" (click)="newSchedule()">
                Manual Schedule
            </button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#roundModal" (click)="openRound(0, 0)">Add Round</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#alertTruckerModal" (click)="openAlertTrucker()">
                Send Text Alert
            </button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#confirmTruckersModal" (click)="confirmTruckers()">Trucker Confirmation</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#locationConfirmModal" (click)="confirmOrigin()">Origin Confirmation</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#locationConfirmModal" (click)="confirmDestination()">Destination Confirmation</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="clearSorting()">Default Sort</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="exportGrid()">Export</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="clearFiltersClick()">Clear Filters</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" [disabled]="!useDefaultFilters" (click)="saveDefaultFilters()" *ngIf="!savingDefaultFilters">Save Filters</button>
            <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="savingDefaultFilters">
                <span class="spinner-border spinner-border-sm me-1"></span>
                <span>Saving...</span>
            </button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" [disabled]="!useDefaultFilters" (click)="loadDefaultFilters()">Restore Filters</button>
        </div>
        <div class="dropdown" *ngIf="showLoadsByDay">
            <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Legend
            </button>
            <div class="dropdown-menu light-background">
                <div style="width: 350px;">
                    <div class="row ms-2 mb-1">
                        <div class="col-1 border loads-status-noloads"></div>
                        <div class="col-11">no actual loads</div>
                    </div>
                    <div class="row ms-2 mb-1">
                        <div class="col-1 border loads-status-toofew"></div>
                        <div class="col-11">actual loads less than estimated loads</div>
                    </div>
                    <div class="row ms-2 mb-1">
                        <div class="col-1 border loads-status-match"></div>
                        <div class="col-11">actual loads equals estimated loads</div>
                    </div>
                    <div class="row ms-2 mb-1">
                        <div class="col-1 border loads-status-toomany"></div>
                        <div class="col-11">actual loads exceeds estimated loads</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="dropdown">
                <button class="btn btn-sm btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        aria-label="Keyboard shortcuts for Schedule and Dispatch forms"
                        title="Hotkeys">
                    <i class="fa-solid fa-circle-info me-1"></i>
                </button>
                <div class="dropdown-menu light-background" style="font-size: 0.875rem;">
                    <div style="width: 370px; padding: 12px;">
                        <div class="mb-2 pb-2 border-bottom">
                            <small class="text-muted" style="font-size: 0.8rem;"><i class="fa-solid fa-circle-info me-1"></i>Keyboard shortcuts for Schedule and Dispatch forms</small>
                        </div>

                        <div class="mb-1">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">Ctrl</kbd>+<kbd class="small">S</kbd></div>
                                <div>Save & Close</div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">Ctrl</kbd>+<kbd class="small">Shift</kbd>+<kbd class="small">S</kbd></div>
                                <div>Save & New</div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">Escape</kbd></div>
                                <div>Cancel</div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">Tab</kbd></div>
                                <div>Next field</div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">Shift</kbd>+<kbd class="small">Tab</kbd></div>
                                <div>Previous field</div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">↑</kbd> <kbd class="small">↓</kbd></div>
                                <div>Navigate dropdowns</div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div><kbd class="small">Enter</kbd></div>
                                <div>Select / Toggle</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<div class="drop-menu">
            <a href="#" class="grid-icon-btn menu-btn" title="menu"><i class="fa-solid fa-square-caret-down fa-lg"></i></a>
            <div class="menu-items">
                <div><a class="btn1" href="#"><i class="fa-solid fa-pen-to-square fa-lg"></i> menu 1</a></div>
                <div><a class="btn2" href="#">menu 2</a></div>
            </div>
        </div>-->
    </div>
</div>
<div class="row border rounded m-1 p-1">
    <form role="form">
        <div class="row row-cols-lg-auto gx-2 align-items-center">
            <label class="col-form-label-sm">Trucker:</label>
            <div class="col-12">
                <select name="trucker" class="form-select form-select-sm select-m" [(ngModel)]="scheduleParameters.truckerId" (change)="getDispatchFilterLists()">
                    <option value="0"></option>
                    <option *ngFor="let item of truckerList" [ngValue]="item.id">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">{{dispatchTypeLabel}}:</label>
            <div class="col-12">
                <select name="location" class="form-select form-select-sm select-m" [(ngModel)]="scheduleParameters.locationName" (change)="getDispatchFilterLists()">
                    <option value="0"></option>
                    <option *ngFor="let item of locationList" [ngValue]="item.value">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">{{dispatchTypeLabel}} City:</label>
            <div class="col-12">
                <select name="locationCity" class="form-select form-select-sm select-sm" [(ngModel)]="scheduleParameters.locationCity" (change)="getDispatchFilterLists()">
                    <option value="0"></option>
                    <option *ngFor="let item of locationCityList" [ngValue]="item.value">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">Load Date:</label>
            <div class="col-12">
                <select name="loadDate" class="form-select form-select-sm" [(ngModel)]="scheduleParameters.loadDate" (change)="refreshScheduleData()">
                    <option value=""></option>
                    <option *ngFor="let item of scheduleDaysList" [ngValue]="item.value">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">Delivery Date:</label>
            <div class="col-12">
                <select name="deliveryDate" class="form-select form-select-sm" [(ngModel)]="scheduleParameters.deliveryDate" (change)="refreshScheduleData()">
                    <option value=""></option>
                    <option *ngFor="let item of scheduleDaysList" [ngValue]="item.value">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">Load/Unload&nbsp;#:</label>
            <div class="col-12">
                <input type="text" class="form-control form-control-sm" style="width:120px;" [(ngModel)]="scheduleParameters.loadNumber" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-12">
                <button type="submit" class="btn btn-sm btn-outline-primary" (click)="refreshScheduleData()">
                    <i class="fa-solid fa-filter"></i>
                </button>
            </div>
        </div>
    </form>
</div>

<div class="m-1">
    <pqgrid #scheduleGrid [options]="scheduleOptions"></pqgrid>
</div>

<div class="m-1 mt-2 d-flex justify-content-end gap-3">
    <span class="badge bg-primary bg-opacity-75">Loads: {{totals().loads | number}}</span>
    <span class="badge bg-primary bg-opacity-75">Disp: {{totals().dispatched | number}}</span>
    <span class="badge bg-primary bg-opacity-75">Bal: {{totals().balance | number}}</span>
    <span class="badge bg-primary bg-opacity-75">Un-Assign: {{totals().unassigned | number}}</span>
    <span class="badge bg-primary bg-opacity-75">Un-Conf: {{totals().unconfirmed | number}}</span>
    <span class="badge bg-primary bg-opacity-75">Conf: {{totals().confirmed | number}}</span>
</div>

<schedule-form [scheduleDefaults]="scheduleForm" (saveComplete)="scheduleSaveComplete($event)" (deleteComplete)="scheduleDeleteComplete($event)"></schedule-form>

<dispatch-form [dispatchParameters]="dispatchForm" [dispatchFormId]="dispatchFormId" (saveComplete)="scheduleSaveComplete($event)" (deleteComplete)="refreshScheduleList($event)"></dispatch-form>

<copy-dispatch [copyDispatchParameters]="copyDispatchParameters" [copyDispatchModalId]="copyDispatchModalId" (saveComplete)="scheduleSaveComplete($event)"></copy-dispatch>

<alert-trucker-form [alertParameters]="alertTruckerForm" [alertTruckerFormId]="alertTruckerFormId" (sendComplete)="scheduleSaveComplete($event)"></alert-trucker-form>

<confirm-dispatch [dispatchId]="sendDispatchId" [refresh]="sendDispatchRefresh" (sendComplete)="refreshScheduleList($event)"></confirm-dispatch>

<confirm-truckers [scheduleParameters]="planningParameters" [refresh]="sendDispatchRefresh" (sendComplete)="refreshScheduleList($event)">></confirm-truckers>

<loads-status [dispatchId]="loadsStatusDispatchId" [refresh]="loadsStatusRefresh" [parentComponent]="'schedules'" [showAllRecords]="true"></loads-status>

<texts-status [dispatchId]="textsStatusDispatchId" [refresh]="textsStatusRefresh" [parentComponent]="'schedules'"></texts-status>

<app-email-question-form [emailQuestionParameters]="emailQuestionForm" [emailQuestionFormId]="emailQuestionFormId"></app-email-question-form>

<move-split-dispatch-form [moveSplitDispatchFormParams]="moveSplitDispatchFormParams" [moveSplitFormId]="moveSplitFormId" (saveComplete)="scheduleSaveComplete($event)"></move-split-dispatch-form>

<load-bank-apply [parameters]="loadBankApplyParameters" [loadBankApplyFormId]="loadBankApplyFormId" (loadBankApplyComplete)="loadBankApplyComplete($event)"></load-bank-apply>

<round-form [parameters]="roundParameters" [roundFormId]="roundFormId" (roundComplete)="roundComplete($event)"></round-form>

<copy-round [parameters]="roundParameters" [copyRoundFormId]="copyRoundFormId" (roundComplete)="roundComplete($event)"></copy-round>

<toast-notification #toastNotification></toast-notification>

<delete-confirm #deleteComponent *ngIf="deleteItemParams" [deleteItemParameters]="deleteItemParams" [deleteFormId]="deleteConfirmFormId" (confirmEmitter)="deleteItem($event, deleteItemParams)"></delete-confirm>

<location-confirmation [confirmInfo]="locationConfirmInfo"></location-confirmation>




